import { render, staticRenderFns } from "./DataManagerJob.vue?vue&type=template&id=2fa56686&"
import script from "./DataManagerJob.vue?vue&type=script&lang=js&"
export * from "./DataManagerJob.vue?vue&type=script&lang=js&"
import style0 from "./DataManagerJob.vue?vue&type=style&index=0&id=2fa56686&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports